import { gql } from '@apollo/client';

const GET_CUSTOM_TEACHING_ORDERS = gql`
  query {
    customTeachingOrders {
      id
      name
      active
      characters {
        id
        character
        characterCase
        characterType
      }
    }
  }
`;

export default GET_CUSTOM_TEACHING_ORDERS;
